import { Facebook, Instagram, MessageCircle, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { ayurvedicTreatments, otherTreatments } from "@/data/treatments";

const Footer = () => {
  const year = new Date().getFullYear();
  const quickLinks = [...ayurvedicTreatments.slice(0, 5), ...otherTreatments.slice(0, 1)];

  return (
    <footer style={{ backgroundColor: "hsl(var(--espresso))" }} className="text-white/85">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-3xl text-white">ORIGINI</h3>
            <p className="font-serif italic text-lg text-[#e9be74] mt-1">tra radici ed ali</p>
            <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-xs">
              Studio Olistico specializzato in Ayurveda e riflessologia plantare
              a Montemerlo di Cervarese Santa Croce. Trattamenti naturali e
              personalizzati per il riequilibrio di mente, corpo e spirito.
            </p>
          </div>

          {/* Trattamenti */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#e9be74] mb-4">Trattamenti</p>
            <ul className="space-y-2 text-sm">
              {quickLinks.map((t) => (
                <li key={t.slug}>
                  <Link
                    to={`/trattamenti/${t.slug}`}
                    className="text-white/75 hover:text-white transition-colors"
                  >
                    {t.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/trattamenti" className="text-[#e9be74] hover:text-white transition-colors">
                  Tutti i trattamenti →
                </Link>
              </li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#e9be74] mb-4">Contatti</p>
            <ul className="space-y-3 text-sm text-white/75">
              <li className="flex gap-3 items-start">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#e9be74]" />
                <a
                  href="https://maps.app.goo.gl/qixtEbsHeB6ssbyP7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Via Roma, 334 — 35030 Montemerlo di Cervarese Santa Croce (PD)
                </a>
              </li>
              <li className="flex gap-3 items-start">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#e9be74]" />
                <a href="https://wa.me/393461533000" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  +39 346 153 3000
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://www.facebook.com/profile.php?id=100063754114071" target="_blank" rel="noopener noreferrer" className="text-white/75 hover:text-[#e9be74] transition-colors" aria-label="Facebook">
                <Facebook size={22} />
              </a>
              <a href="https://www.instagram.com/origini_radici_ali/" target="_blank" rel="noopener noreferrer" className="text-white/75 hover:text-[#e9be74] transition-colors" aria-label="Instagram">
                <Instagram size={22} />
              </a>
              <a href="https://wa.me/393461533000" target="_blank" rel="noopener noreferrer" className="text-white/75 hover:text-[#e9be74] transition-colors" aria-label="WhatsApp">
                <MessageCircle size={22} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/55">
          <p>&copy; {year} ORIGINI — Studio Olistico Ayurvedico</p>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/cookie-policy" className="hover:text-white transition-colors">
              Cookie Policy
            </Link>
            <a
              href="https://www.wmind.it"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Credits
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
